import axios from "./index";

class SedesApi {
  static fetchSedes = () => {
    return axios.get(`/procesos/sedes/`);
  };

  static fetchSedeById = (sedeId) => {
    //console.log("fetchSedeById.sedeId: " + sedeId);
    return axios.get(`/procesos/sedes/${sedeId}/`);
  };

  static createSede = (data) => {
    return axios.post(`/procesos/sedes/crear/`, data);
  };

  static updateSede = (id, data) => {
    return axios.put(`/procesos/sedes/${id}/actualizar/`, data);
  };

  static deleteSede = (id) => {
    return axios.delete(`/procesos/sedes/${id}/eliminar/`);
  };
}
export default SedesApi;
